module.exports = [
  '>0.25%',
  'not ie 11',
  'not op_mini all',
  'not dead',
  'Firefox ESR',
];
